import { BrowserVendorService } from '../browser/browser-vendor.service';
import * as Noty from 'noty';

export function notyInitializer (browserVendorService:BrowserVendorService):Function {
  return ():void => {
    (<any>Noty).overrideDefaults({
      layout: 'top',
      theme: 'bootstrap-v3',
      animation: {
        open: browserVendorService.gradeC? null : 'animated animated-fast slideInDown',
        close: browserVendorService.gradeC? null : 'animated animated-fast slideOutUp'
      }
    });
  };
}